module.exports = __webpack_public_path__ + "img/مربع-1.e8be86a1.png";